var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"btn btn--ghost btn--default",style:((_vm.$vuetify.breakpoint.xsOnly) ? 'width: 100%;' : ''),attrs:{"href":'/' + _vm.store.terminologyId + '/'}},[_vm._v(_vm._s(_vm.store.terminologyId))])
}
var staticRenderFns = []

export { render, staticRenderFns }